<template>
	<v-card
		class="sgnl-p-16"
		width="100%"
		variant="outlined"
		data-test="data-source-picker-card"
	>
		<template v-if="dataSourceData">
			<div class="sgnl-flex sgnl-flex-column data-source-card-content">
				<v-row no-gutters>
					<v-col
						data-test="data-source-picker-card-title"
						class="sgnl-flex sgnl-align-center sgnl-paragraph-m-medium sgnl-text-color-default sgnl-gap-4"
					>
						<FolderShared16
							v-if="dataSourceType === 'SignaloidCloudStorage'"
							class="sgnl-icon-color-secondary"
						/>
						<span
							v-else-if="dataSourceType === 'Bucket'"
							class="data-source-icon data-source-icon--bucket"
							role="img"
							aria-label="S3 Bucket"
						/>
						<span
							v-else-if="dataSourceType === 'Drive'"
							class="data-source-icon data-source-icon--drive"
							role="img"
							aria-label="Data Drive"
						/>
						<v-icon v-else>{{ dataSourceIcon(dataSourceType) }}</v-icon>
						{{ dataSourceData.Name }}
					</v-col>
					<v-col
						v-if="dataSourceType == 'Gateway'"
						cols="auto"
						class="sgnl-mx-8 sgnl-flex sgnl-flex-column sgnl-gap-4"
						align-self="start"
					>
						<template v-if="gatewayStatusLoading">
							<v-progress-circular color="primary" />
						</template>
						<template v-else>
							<v-tooltip open-delay="500">
								<template v-slot:activator="{ props }">
									<v-icon
										variant="outlined"
										size="20"
										:color="gatewayStatusIcon.colour"
										class="sgnl-mt-0 sgnl-pt-0"
										v-bind="props"
									>
										{{ gatewayStatusIcon.icon }}</v-icon
									>
								</template>
								<span
									>{{ gatewayStatus }} <br />
									Last active: {{ gatewayLastUpdatedString }}</span
								>
							</v-tooltip>
						</template>

						<v-tooltip open-delay="500">
							<template v-slot:activator="{ props }">
								<div
									class="sgnl-paragraph-s-regular gateway-ip-address"
									v-bind="props"
								>
									{{ gatewayIPAddress }}
								</div>
							</template>
							<span>Gateway Local IP address</span>
						</v-tooltip>
					</v-col>
				</v-row>
				<v-row
					no-gutters
					class="sgnl-paragraph-s-regular"
					align="end"
				>
					<v-col class="sgnl-flex sgnl-flex-column sgnl-gap-8">
						<div
							v-if="dataSourceType == 'Bucket'"
							class="sgnl-flex sgnl-align-center sgnl-flex-wrap sgnl-gap-8"
						>
							<span
								class="entity-card__badge sgnl-text-color-secondary sgnl-caption-regular"
								:class="{ 'entity-card__badge--warning': !dataSourceData.Read }"
							>
								<Checkmark16 v-if="dataSourceData.Read" />
								<Close16 v-else />
								Read
							</span>
							<span
								class="entity-card__badge sgnl-text-color-secondary sgnl-caption-regular"
								:class="{ 'entity-card__badge--warning': !dataSourceData.Write }"
							>
								<Checkmark16 v-if="dataSourceData.Write" />
								<Close16 v-else />
								Write
							</span>
						</div>
						<div
							v-else-if="dataSourceType == 'Drive'"
							class="sgnl-flex sgnl-align-center sgnl-flex-wrap sgnl-gap-8"
						>
							<template v-if="connectedSourceCount > 0">
								<span
									v-if="gatewayCount > 0"
									class="entity-card__badge sgnl-text-color-secondary sgnl-caption-regular"
								>
									<span
										class="data-source-icon data-source-icon--gateway"
										role="img"
										aria-label="Gateway"
									/>
									{{ gatewayCount }} {{ gatewayCount == 1 ? "Gateway" : "Gateways" }}
								</span>
								<span
									v-if="bucketCount > 0"
									class="entity-card__badge sgnl-text-color-secondary sgnl-caption-regular"
								>
									<span
										class="data-source-icon data-source-icon--bucket"
										role="img"
										aria-label="S3 Bucket"
									/>
									{{ bucketCount }} {{ bucketCount == 1 ? "S3 Bucket" : "S3 Buckets" }}
								</span>
								<span
									v-if="signaloidCloudStorageConnected"
									class="entity-card__badge sgnl-text-color-secondary sgnl-caption-regular"
								>
									<FolderShared16 class="sgnl-icon-color-secondary" />
									Cloud Storage
								</span>
							</template>
							<span
								v-else
								class="entity-card__badge entity-card__badge--warning sgnl-caption-regular"
							>
								No Source Mount Points Set
							</span>
						</div>
						<div
							v-else-if="dataSourceType == 'SignaloidCloudStorage'"
							class="sgnl-paragraph-s-regular sgnl-flex sgnl-flex-column sgnl-gap-8"
						>
							<v-row
								no-gutters
								align="center"
							>
								<v-col
									cols="auto"
									class="sgnl-text-color-default"
									>Usage</v-col
								>
								<v-spacer />
								<v-col
									cols="auto"
									class="sgnl-caption-regular sgnl-text-color-secondary"
									v-if="!signaloidCloudStorageLoading"
								>
									{{ formatUsageString(dataSourceData.storageUsage) }} of
									{{ formatUsageString(dataSourceData.storageAllowance) }}
								</v-col>
							</v-row>
							<v-progress-linear
								height="6"
								:color="usageBarColour"
								:model-value="usagePercentage"
							/>
							<!-- <v-icon
							class="sgnl-mr-4"
							size="small"
						 icon="mdi-tray-arrow-down" />
						<template v-if="connectedSourceCount>0">
							Source Mount Points:
							<template v-if="gatewayCount !=0">
								<v-icon
									class="sgnl-ml-4"
									size="small"
								>{{dataSourceIcon("Gateway")}}</v-icon>
								{{gatewayCount}} {{gatewayCount==1?'Gateway':'Gateways'}}
							</template>
							<template v-if="bucketCount !=0">
								<v-icon
									class="sgnl-ml-4"
									size="small"
								>{{dataSourceIcon("Bucket")}}</v-icon>
								{{bucketCount}} {{bucketCount==1?'S3 Bucket':'S3 Buckets'}}
							</template>
						</template>
						<template v-else>No Source Mount Points Set!</template> -->
						</div>
						<!-- <div class="sgnl-mr-12">
						<v-icon
							class="sgnl-mr-4"
							size="small"
						 icon="mdi-checkbox-marked-circle-plus-outline" />Created at {{formatDate(dataSourceData.CreatedAt)}}
					</div> -->
						<div
							class="sgnl-flex sgnl-align-center sgnl-text-color-secondary sgnl-gap-4"
							v-if="dataSourceType != 'SignaloidCloudStorage'"
						>
							<Time16 class="sgnl-icon-color-secondary" />Last Updated:
							{{ formatDateDayString(dataSourceData.UpdatedAt) }}
						</div>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-btn
						:variant="setAsSource ? 'outlined' : 'flat'"
						:color="setAsSource ? 'error' : 'primary'"
						@click="setSourceBtnHandler"
						data-test="set-data-source-button"
					>
						<component :is="setSourceBtnIcon(setAsSource, false).icon" />
						<span>{{ setAsSource ? "Unmount Data Source" : "Mount Data Source" }}</span>
					</v-btn>
				</v-row>
			</div>
		</template>
		<div
			v-else
			class="sgnl-flex sgnl-flex-column data-source-card-content"
		>
			<div class="sgnl-flex sgnl-align-center sgnl-gap-4">
				<SkeletonBlock
					width="var(--sgnl-icon-20)"
					height="var(--sgnl-icon-20)"
				/>
				<SkeletonBlock
					width="55%"
					class="sgnl-paragraph-m-medium"
				/>
			</div>
			<div class="sgnl-flex sgnl-flex-column sgnl-gap-8">
				<div class="sgnl-flex sgnl-align-center sgnl-flex-wrap sgnl-gap-8">
					<SkeletonBlock
						width="70px"
						height="22px"
						radius="var(--sgnl-border-radius-6)"
					/>
					<SkeletonBlock
						width="70px"
						height="22px"
						radius="var(--sgnl-border-radius-6)"
					/>
				</div>
				<SkeletonBlock
					width="40%"
					class="sgnl-paragraph-s-regular"
				/>
			</div>
			<SkeletonBlock
				width="180px"
				btn
			/>
		</div>
	</v-card>
</template>

<script lang="ts">
import { defineComponent, markRaw, PropType } from "vue";
import DataError16 from "@carbon/icons-vue/es/data--error/16";
import DataCheck16 from "@carbon/icons-vue/es/data--check/16";
import DataEnrichmentAdd16 from "@carbon/icons-vue/es/data-enrichment--add/16";
import Checkmark16 from "@carbon/icons-vue/es/checkmark/16";
import Close16 from "@carbon/icons-vue/es/close/16";
import Time16 from "@carbon/icons-vue/es/time/16";
import FolderShared16 from "@carbon/icons-vue/es/folder--shared/16";
import { sdk } from "@/js/sdk";

import * as dsUtil from "@/components/DataSources/utilities";
import { DataSourceType } from "@/types/api/dataSources";
import { useUserStore } from "@/stores/user";
import { monitoringCaptureError } from "@/plugins/monitoring";
import ChartRing16 from "@carbon/icons-vue/es/chart--ring/16";
import SkeletonBlock from "@/components/Common/SkeletonBlock.vue";

type ComponentData = {
	dataSourceData: any; //FIXME:
	showEditNameDialog: boolean;
	gatewayStatus: string;
	gatewayStatusIcon: any; //FIXME:
	gatewayStatusLoading: boolean;
	gatewayLastUpdated: undefined | number;
	signaloidCloudStorageLoading: boolean;
};

export default defineComponent({
	name: "DataSourcePickerCard",
	components: {
		DataError16,
		DataCheck16,
		DataEnrichmentAdd16,
		ChartRing16,
		Checkmark16,
		Close16,
		Time16,
		FolderShared16,
		SkeletonBlock,
	},
	emits: ["reset-data-source", "set-data-source"],
	props: {
		dataSourceID: { type: String, required: true },
		dataSourceType: { type: String as PropType<DataSourceType>, required: true },
		setAsSource: { type: Boolean, default: false },
	},
	setup() {
		const userStore = useUserStore();
		return { userStore };
	},
	data: (): ComponentData => ({
		dataSourceData: undefined,
		showEditNameDialog: false,
		gatewayStatus: "Disconnected",
		gatewayStatusIcon: {},
		gatewayStatusLoading: false,
		gatewayLastUpdated: undefined,
		signaloidCloudStorageLoading: false,
	}),
	methods: {
		async getSourceInfo() {
			switch (this.dataSourceType) {
				case "Gateway":
					try {
						const resp = await sdk.things.getOne(this.dataSourceID);
						this.dataSourceData = resp;
						this.getGatewayStatus();
					} catch (error) {
						monitoringCaptureError(error, "Fetch data source info");
					}
					break;
				case "Bucket":
					try {
						const resp = await sdk.buckets.getOne(this.dataSourceID);
						this.dataSourceData = resp;
					} catch (error) {
						monitoringCaptureError(error, "Fetch data source info");
					}
					break;
				case "Drive":
					try {
						const resp = await sdk.drives.getOne(this.dataSourceID);
						this.dataSourceData = resp;
					} catch (error) {
						monitoringCaptureError(error, "Fetch data source info");
					}
					break;
				case "SignaloidCloudStorage":
					try {
						this.dataSourceData = {
							Name: "Signaloid Cloud Storage",
							storageUsage: 0.0,
							storageAllowance: 1,
						};

						this.signaloidCloudStorageLoading = true;
						// get user usage
						//FIXME: The storage doesn't seem to update until manual refresh
						const userID = await this.userStore.getCurrentUserID();
						const userDetails = await sdk.users.getOne(userID);
						this.dataSourceData.storageUsage =
							userDetails?.ResourceUsage?.CloudStorageBytes ??
							// @ts-ignore: FIXME: This is a legacy key which we should check for now
							userDetails?.ResourceUsage?.DataStorage ??
							"--";

						const tierDetails = await this.userStore.getCurrentUserTierDetails();
						this.dataSourceData.storageAllowance = tierDetails?.allowance.CloudStorageBytes ?? "--";
					} catch (error) {
						monitoringCaptureError(error, "Fetch data source info");
					} finally {
						this.signaloidCloudStorageLoading = false;
					}
					break;
				default:
					this.$emit("reset-data-source");
					throw "Error: Unexpected source type";
			}
		},
		setSourceBtnHandler() {
			this.setAsSource
				? this.$emit("reset-data-source")
				: this.$emit("set-data-source", {
						ResourceID: this.dataSourceID,
						ResourceType: this.dataSourceType,
					});
		},
		setSourceBtnIcon(setAsSource: boolean, hover: boolean) {
			if (setAsSource && hover) {
				return { icon: markRaw(DataError16), colour: "warning" };
			} else if (setAsSource && !hover) {
				return { icon: markRaw(DataError16), colour: "success" };
			} else {
				//  setAsSource is false
				return { icon: markRaw(DataCheck16), colour: "success" };
			}
		},
		dataSourceIcon(dataSourceType: DataSourceType) {
			return dsUtil.dataSourceIcon(dataSourceType);
		},
		formatDateDayString(msSinceEpoch: number) {
			return dsUtil.formatDateDayString(1000 * msSinceEpoch);
		},
		formatDate(msSinceEpoch: number) {
			return dsUtil.formatDateStandardString(msSinceEpoch);
		},
		// * Gateway functions
		async getGatewayStatus() {
			this.gatewayStatusLoading = true;
			this.gatewayLastUpdated = await dsUtil.gatewayLastUpdated(this.dataSourceData);
			this.gatewayStatus = dsUtil.gatewayStatusFromLastUpdated(this.gatewayLastUpdated);
			this.gatewayStatusIcon = dsUtil.gatewayStatusIcon(this.gatewayStatus);
			if (this.gatewayStatusIcon) {
				this.gatewayStatusLoading = false;
			}
		},
		// * SignaloidCloudStorage functions
		formatUsageString(usageInBytes: number) {
			if (usageInBytes >= 1e9) {
				return `${(usageInBytes / 1e9).toFixed(2)} GB`;
			} else if (usageInBytes >= 1e6) {
				return `${(usageInBytes / 1e6).toFixed(2)} MB`;
			} else if (usageInBytes >= 1e3) {
				return `${(usageInBytes / 1e3).toFixed(2)} KB`;
			} else {
				return `${usageInBytes} B`;
			}
		},
	},
	computed: {
		// * Gateway functions
		gatewayIPAddress(): string {
			return dsUtil.gatewayIPAddressString(this.dataSourceData);
		},
		gatewayIPKnown(): boolean {
			return dsUtil.gatewayIPKnown(this.dataSourceData);
		},
		gatewayLastUpdatedString(): string {
			if (!this.gatewayLastUpdated) {
				return "---";
			}
			return dsUtil.formatDateDayString(1000 * this.gatewayLastUpdated);
		},

		// * Drive functions
		gatewayCount(): number {
			if (!Array.isArray(this.dataSourceData.DataSources)) {
				// log some error
				return 0;
			}
			// @ts-ignore FIXME:
			return this.dataSourceData.DataSources.filter((source) => {
				return source.ResourceType === "Gateway";
			}).length;
		},
		bucketCount(): number {
			if (!Array.isArray(this.dataSourceData.DataSources)) {
				// log some error
				return 0;
			}
			// @ts-ignore FIXME:
			return this.dataSourceData.DataSources.filter((source) => {
				return source.ResourceType === "Bucket";
			}).length;
		},
		signaloidCloudStorageConnected(): boolean {
			if (!Array.isArray(this.dataSourceData.DataSources)) {
				return false;
			}
			// @ts-ignore FIXME:
			return this.dataSourceData.DataSources.some((source) => {
				return source.ResourceType === "SignaloidCloudStorage";
			});
		},
		connectedSourceCount(): number {
			if (!Array.isArray(this.dataSourceData.DataSources)) {
				return 0;
			}
			return this.dataSourceData.DataSources.length;
		},

		// * SignaloidCloudStorage functions
		usageBarColour() {
			if (this.usagePercentage >= 90) {
				return "danger";
			} else if (this.usagePercentage >= 80) {
				return "warning";
			}
			return "var(--sgnl-brand-background)";
		},
		usagePercentage(): number {
			if (!this.dataSourceData) {
				return 0;
			}
			// @ts-ignore FIXME:
			return (100 * this.dataSourceData.storageUsage) / this.dataSourceData.storageAllowance;
		},
	},
	mounted() {
		this.getSourceInfo();
	},
});
</script>

<style lang="scss" scoped>
.data-source-card-content {
	gap: var(--sgnl-space-16);
}

.gateway-ip-address {
	display: inline;
}
</style>
